import { IpService } from './ip.service';
import { Injectable } from '@angular/core';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Injectable({
    providedIn: 'root'
})

export class CookieService {
    constructor(
        private gaService: GoogleAnalyticsService,
        private IpService: IpService
    ) {
    }

    setCookieConsent() {
        localStorage.setItem('COOKIE_CONSENT_TOTALDOCS', 'TRUE');
        this.IpService.getIp().subscribe(
            (res: any) => {
                const cookieEvent = '{ "data": \"' + new Date().toLocaleString() + '\", "ip": \"' + res.ip + '\" }';
                this.gaService.event('submit', 'cookie_consent_totaldocs', cookieEvent);
            },
            err => {
                const cookieEvent = '{ "data": \"' + new Date().toLocaleString() + '\" }';
                this.gaService.event('submit', 'cookie_consent_totaldocs', cookieEvent);
            }
        );
    }

    getCookieConsent() {
        return localStorage.getItem('COOKIE_CONSENT_TOTALDOCS');
    }
}
